import { Button } from '@amway/react-components';
import { useMemo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DateRangeFieldsComponent from '../../../components/ui/date-range-fields';
import DropdownBtn, { Item } from '../../../components/ui/dropdown-btn';
import { ChartOption, DateAggregation, getChartOptionLabel } from '../../../interface/reports';
import './index.scss';

type Props = {
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
  maxDate: string;
  submit: () => void;
  loading: boolean;
  chartOption: Item | undefined | null;
  setChartOption: (chartOption: Item | undefined | null) => void;
  dateAggregation: Item | undefined;
  setDateAggregation: (dateAggregation: Item | undefined) => void;
  loadChartData: (e: any) => void;
};

export default function DashboardMetricsFormComponent({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  maxDate,
  submit,
  loading,
  chartOption,
  setChartOption,
  dateAggregation,
  setDateAggregation,
  loadChartData,
}: Props) {
  const chartOptionTypes = useMemo(
    () =>
      (Object.values(ChartOption).filter(option => !isNaN(Number(option))) ?? []).map(e => ({
        id: ChartOption[Number(e)],
        label: getChartOptionLabel(e as ChartOption),
      })),
    [],
  );

  const dateAggregationTypes = useMemo(
    () =>
      (Object.values(DateAggregation).filter(dateAggregation => !isNaN(Number(dateAggregation))) ?? []).map(d => ({
        id: DateAggregation[Number(d)],
        label: DateAggregation[Number(d)],
      })),
    [],
  );
  return (
    <Form className="dashboard-metrics-form" onSubmit={submit}>
      <Row>
        <DateRangeFieldsComponent
          sm={12}
          md={4}
          lg={4}
          xl={3}
          xxl={3}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          maxDate={maxDate}
        />
        <Col className="d-flex justify-content-center align-items-end" sm={12} md={4} lg={4} xl={3} xxl={3}>
          <Button onClick={() => loadChartData} loading={loading}>
            UPDATE
          </Button>
        </Col>
        <Col>
          <DropdownBtn
            id="chart-option-dropdown"
            label="Chart Type"
            placeholder="Select a chart type"
            items={chartOptionTypes}
            value={chartOption as Item}
            onClick={setChartOption as unknown as (item?: Item | null) => void}
          />
        </Col>
        <Col hidden={chartOption?.id !== ChartOption[ChartOption.EXECUTIONS_OVER_TIME]}>
          <DropdownBtn
            id="date-aggregation-dropdown"
            label="Date Aggregation"
            placeholder="Set the date aggregate"
            items={dateAggregationTypes}
            value={dateAggregation}
            onClick={setDateAggregation as unknown as (item?: Item | null) => void}
          />
        </Col>
      </Row>
    </Form>
  );
}
